import React from "react";
import Select from "react-select/lib/Select";

export default function BooleanSelectComponent({ item, onDataChange, index }) {
  const getDropdownValue = () => {
    if (
      item.booleanParameter !== null &&
      typeof item.booleanParameter != "undefined"
    ) {
      if (item.booleanParameter === true) {
        return "IS";
      } else {
        return "IS_NOT";
      }
    } else {
      return "IS";
    }
  };

  const handleOnChange = val => {
    const value = val.value === "IS" ? true : false;
    onDataChange(index, value, "booleanParameter");
  };

  return (
    <div style={{ width: "90px" }}>
      <Select
        options={[
          { label: "Is", value: "IS" },
          { label: "Is Not", value: "IS_NOT" },
        ]}
        value={getDropdownValue()}
        onChange={handleOnChange}
      />
    </div>
  );
}
